export default "__VITE_ASSET__e8ccfa7d__"